import { render } from "./item_price_approve_form.vue?vue&type=template&id=3bee5ae8&scoped=true"
import script from "./item_price_approve_form.vue?vue&type=script&lang=js"
export * from "./item_price_approve_form.vue?vue&type=script&lang=js"

import "./item_price_approve_form.vue?vue&type=style&index=0&id=3bee5ae8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bee5ae8"]])

export default __exports__